import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, of, switchMap, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AziendaService } from '../azienda/azienda.service';
import { WebService } from '../web/web.service';

@Injectable({
  providedIn: 'root',
})
export class FolliaWidgetWebService {
  private _idAzienda: string | undefined = undefined;
  constructor(
    private readonly webService: WebService,
    private readonly aziendaService: AziendaService,
    private readonly httpClient: HttpClient,
  ) {
    this.aziendaService.aziendaCorrente.subscribe((azienda) => {
      this._idAzienda = azienda?.id;
    });
  }

  /**
   * Auth verso Follia: idStoricoChat isola lo storico chat del widget per modulo.
   */
  getJWTFollia(idStoricoChat: string | null) {
    return this.webService.doPost('/api/v1/widget/azienda/' + this._idAzienda + '/auth', {
      id: idStoricoChat,
    });
  }

  getStatoFile(tenantId: string, companyId: string, datasourceId: string, token: string) {
    const { folliaUrl } = environment;

    return this.getStatoFileWidget(
      folliaUrl +
        '/api/v1/tenants/' +
        tenantId +
        '/companies/' +
        companyId +
        '/datasources/' +
        datasourceId +
        '/storage/jobs',
      {},
      token,
    );
  }

  private getStatoFileWidget(
    endpoint: string,
    data: { [key: string]: any },
    token: string,
    responseType: 'json' | 'blob' = 'json',
  ): Observable<any> {
    const url = endpoint;
    const headers = {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    };

    return this.httpClient
      .get(url, {
        headers,
        observe: 'response',
        params: data,
        responseType: responseType as 'json',
        withCredentials: false,
      })
      .pipe(
        switchMap((val) => {
          if (val.status < 200 || val.status > 299) {
            return throwError(() => val);
          }
          return of(val.body);
        }),
        catchError((err) => {
          console.error('Errore API:', err);
          // Rilancio l'errore in modo che finisca nel .catch() della Promise
          return throwError(() => err);
        }),
      );
  }

  public getIdDatasourceDefault(tipo: string) {
    return this.webService.doGet('/api/v1/widget/default-datasource/tipo/' + tipo, {});
  }
}
